import { render } from "./WelcomeCard.vue?vue&type=template&id=1f8a1754&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=ts"
export * from "./WelcomeCard.vue?vue&type=script&lang=ts"

import "./WelcomeCard.vue?vue&type=style&index=0&id=1f8a1754&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f8a1754"

export default script